export enum DashboardPeriodOptions {
    Last30Days = 1,
    CurrentMonth,
    CurrentMonthPreviousYear,
    CurrentQuarter,
    CurrentQuarterPreviousYear,
    CurrentYtd,
    Last365Days
}
